// Endereço oficial da eBuz (decisão do Jonathan em 2026-09-24).
// Fonte única: e-mail, rodapé de site, página legal e JSON-LD leem daqui.
// Site de parceiro (whitelabel, ex.: Arrasta) NÃO usa este endereço: parceiro não assina eBuz.
export const ENDERECO_EBUZ = {
  edificio: 'Edifício Amazônia Empresarial Alphaville',
  logradouro: 'Alameda Mamoré, 687',
  bairro: 'Alphaville Industrial',
  cidade: 'Barueri',
  uf: 'SP',
  cep: '06454-040',
  pais: 'BR',
} as const

/** Uma linha, para rodapé de e-mail e de site. */
export const ENDERECO_EBUZ_LINHA =
  'Alameda Mamoré, 687, Edifício Amazônia Empresarial Alphaville, Alphaville Industrial, Barueri/SP, CEP 06454-040'
